var _style, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2,
    cy: 12,
    r: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.4,8.9L12,12.7L7.6,8.9V4h8.9V8.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.6,15.1l4.4-3.7l4.4,3.7V20H7.6V15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9,8.5L12,10.9L9,8.5V5.2h5.9V8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,15.5l3-2.4l2.9,2.4v0.8H9V15.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer3);
export default __webpack_public_path__ + "static/media/Timer3.26690a6efbfc12e9ac40d11accb5eed2.svg";
export { ForwardRef as ReactComponent };